function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { GALLERY_CONSTS } from 'pro-gallery-lib';
export function getContainerStyle(styleParams) {
  return _objectSpread({}, (styleParams.imageInfoType === GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND || GALLERY_CONSTS.hasHoverPlacement(styleParams.titlePlacement)) && _objectSpread(_objectSpread({}, getBorderStyle(styleParams.itemBorderRadius, styleParams.itemBorderWidth, styleParams.itemBorderColor)), boxShadow(styleParams)));
}

function boxShadow(styleParams) {
  var _boxShadow = {};

  if (styleParams.itemEnableShadow) {
    var itemShadowBlur = styleParams.itemShadowBlur,
        itemShadowDirection = styleParams.itemShadowDirection,
        itemShadowSize = styleParams.itemShadowSize;
    var alpha = -1 * (Number(itemShadowDirection) - 90) / 360 * 2 * Math.PI;
    var shadowX = Math.round(itemShadowSize * Math.cos(alpha));
    var shadowY = Math.round(-1 * itemShadowSize * Math.sin(alpha));
    _boxShadow = {
      boxShadow: shadowX + "px " + shadowY + "px " + itemShadowBlur + "px " + styleParams.itemShadowOpacityAndColor.value
    };
  }

  return _boxShadow;
}

export function getImageStyle(styleParams) {
  return _objectSpread({}, !GALLERY_CONSTS.hasHoverPlacement(styleParams.titlePlacement) && (styleParams.imageInfoType === GALLERY_CONSTS.infoType.NO_BACKGROUND || styleParams.imageInfoType === GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND) && _objectSpread({}, getBorderStyle(styleParams.itemBorderRadius, styleParams.itemBorderWidth, styleParams.itemBorderColor)));
}

function getBorderStyle(borderRadius, borderWidth, borderColor) {
  return _objectSpread({
    overflow: 'hidden',
    borderRadius: borderRadius,
    borderWidth: borderWidth + 'px',
    borderColor: borderColor && borderColor.value
  }, borderWidth && {
    borderStyle: 'solid'
  });
}

export function getOuterInfoStyle(placement, styleParams, mediaHeight, textBoxHeight) {
  var styles = _objectSpread(_objectSpread({}, GALLERY_CONSTS.hasHorizontalPlacement(placement) && {
    height: mediaHeight,
    "float": GALLERY_CONSTS.isRightPlacement(placement) ? 'right' : 'left'
  }), GALLERY_CONSTS.hasVerticalPlacement(placement) && {
    height: textBoxHeight,
    boxSizing: 'content-box'
  });

  if (styleParams.imageInfoType === GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles), getBorderStyle(styleParams.textBoxBorderRadius, styleParams.textBoxBorderWidth, styleParams.textBoxBorderColor)), GALLERY_CONSTS.hasAbovePlacement(placement) && {
      marginBottom: styleParams.textImageSpace
    }), GALLERY_CONSTS.hasBelowPlacement(placement) && {
      marginTop: styleParams.textImageSpace
    });
  }

  return styles;
}

function getInnerInfoStylesAboveOrBelow(styleParams, infoHeight) {
  return {
    width: '100%',
    height: infoHeight
  };
}

function getInnerInfoStylesRightOrLeft(styleParams, infoWidth) {
  return {
    height: '100%',
    width: infoWidth
  };
}

export function getInnerInfoStyle(placement, styleParams, infoHeight, infoWidth) {
  var commonStyles = _objectSpread(_objectSpread({}, (styleParams.imageInfoType === GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND || styleParams.imageInfoType === GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND) && styleParams.textBoxFillColor && styleParams.textBoxFillColor.value && {
    backgroundColor: styleParams.textBoxFillColor.value
  }), {}, {
    overflow: 'hidden',
    boxSizing: 'border-box'
  });

  var infoAboveOrBelow = GALLERY_CONSTS.hasVerticalPlacement(placement);
  var infoRightOrLeft = GALLERY_CONSTS.hasHorizontalPlacement(placement);
  return _objectSpread(_objectSpread(_objectSpread({}, commonStyles), infoAboveOrBelow && getInnerInfoStylesAboveOrBelow(styleParams, infoHeight)), infoRightOrLeft && getInnerInfoStylesRightOrLeft(styleParams, infoWidth));
}